import { ADMIN_CREDENTIALS_STORAGE_KEY, canAccessFinancialMenu } from '@/constants/auth'
import { getCredentials } from '@/helpers/credentials'
import ability from './ability'

const canAccessFixedFinancialRoute = to => {
  if (!to.matched.some(route => route.meta.fixedFinancialMenuRole)) {
    return undefined
  }

  const credentials = getCredentials(ADMIN_CREDENTIALS_STORAGE_KEY)
  if (canAccessFinancialMenu(credentials?.user?.user_role_id)) return true

  // Perfis consultivos (ex.: Intelligence - Consultor Financeiro) acessam a rota
  // financeira em modo leitura via ability (CASL) sobre o resource do meta.
  return to.matched.some(route => {
    if (!route.meta.fixedFinancialMenuRole) return false
    const { resource } = route.meta || {}
    return resource ? ability.can('read', resource) : false
  })
}

export const canNavigate = to => {
  const fixedFinancialAccess = canAccessFixedFinancialRoute(to)
  if (fixedFinancialAccess !== undefined) return fixedFinancialAccess

  return to.matched.some(route => {
    const { action, resource, additionalResource } = route.meta || {}
    return ability.can(action || 'read', resource) ||
      (additionalResource && ability.can(action || 'read', additionalResource))
  })
}

export const _ = undefined
